<template>
    <div>
        <v-form ref="frmPositionExperience" lazy-validation class="form-inputs">
            <v-row>
                <v-card class="tab-item-card mt-5">
                    <v-card-title>
                        <v-row no-gutters>
                            Years of experience in {{ positionName }}
                            <v-spacer></v-spacer>
                            <v-btn @click="cancel" color="red" size="small" icon="mdi-close" class="ml-5">
                              <v-icon></v-icon>
                            </v-btn>
                          </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12" lg="12" sm="12">
                                <AutoCompleteField placeholder="Years of experience related to the position"
                                    dense outlined :items="experienceYears"
                                    v-model="positionExperienceYear" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-col md="12">
                          <v-btn color="secondary" @click="save"><v-icon>mdi-check</v-icon> Save</v-btn>
                          <v-btn color="primary" class="ml-2" @click="cancel">Cancel</v-btn>
                        </v-col>
                      </v-card-actions>
                </v-card>
            </v-row>
        </v-form>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import { Profile } from "../../definitions/config";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";

export default defineComponent({
    props: ["experienceYear","positionName"],
    components: {
        AutoCompleteField,
    },
    data() {
        return {
            experienceYears: Profile.Members.SkillExperienceList,
            positionExperienceYear: "",
        };
    },
    methods: {

        cancel(): void {
            this.$emit("cancel");
        },


        save() {
            this.$emit("saveExperienceYear", this.positionExperienceYear)
        },
    },
    mounted(){
        if (this.experienceYear) {
            this.positionExperienceYear = this.experienceYear;
        }
    }
});
</script>
